module.exports = __webpack_public_path__ + "static/media/canela-light_italic.a764794b.woff2";